let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hOb79")).then(() => parcelRequire('gCWwJ'));